import { Injectable, Type } from "@angular/core";
import { PrimaryLookupService } from "./PrimaryLookupService";

export function ModelUpdate(modelType: Type<any>) {
  return function (
    target: PrimaryLookupService<any, any>,
    propertyKey: string,
    descriptor: PropertyDescriptor,
  ) {
    if (descriptor === undefined) {
      descriptor = Object.getOwnPropertyDescriptor(target, propertyKey);
    }

    var originalMethod = descriptor.value;

    target.registerModelUpdateEventListener(modelType, originalMethod);

    return descriptor;
  };
}
